import { Component, input, output } from '@angular/core'
import { IconButtonComponent } from '../icon-button/icon-button.component'

/** Shared mobile group heading layout with an optional collapse control. */
@Component({
  selector: 'aw-group-header',
  templateUrl: './group-header.component.html',
  styleUrl: './group-header.component.scss',
  imports: [IconButtonComponent]
})
export class GroupHeaderComponent {
  /** Text used when the caller does not project a linked label. */
  readonly label = input('')
  /** Whether the group content is currently visible. */
  readonly expanded = input(true)
  /** Adds the row toggle and the trailing chevron button. */
  readonly collapsible = input(false)
  /** Disables collapsing while the caller is showing filtered content. */
  readonly toggleDisabled = input(false)
  /** Accessible name for the collapse button. */
  readonly toggleLabel = input<string>()
  /** Id of the content controlled by the collapse button. */
  readonly controlsId = input<string>()
  readonly toggled = output<void>()

  /**
   * Toggles the group content unless collapsing is disabled.
   * The chevron host still receives taps when its inner button is disabled.
   */
  toggle(): void {
    if (this.toggleDisabled()) {
      return
    }

    this.toggled.emit()
  }
}
